/* Definitions of actions coming from the cluster (hooked from app events) */
export const INITIALIZE_CHAT = 'app-action/initialize-chat';
export const START_CHAT_TECHNICAL = 'app-action/start-chat-technical';
export const START_CHAT_CANCELLATION = 'app-action/start-chat-cancellation';
export const CLIENT_TOKEN_UPDATED = 'app-action/client-token-updated';
export const SG_SITE_PAGE_LOADED = 'app-action/sg-site-page-loaded';
export const INDICATE_CHAT_IS_ACTIVE = 'app-action/indicate-chat-is-active';
export const SET_OPTIONS = 'app-action/update-chat-options';

export const startChatTechnical = (launchParameters) => ({
  type: START_CHAT_TECHNICAL,
  payload: {
    ...launchParameters
  }
});

export const startChatCancellation = ({ client, cancellation, cur_code, local_phone, request_id }) => ({
  type: START_CHAT_CANCELLATION,
  payload: {
    client,
    cancellation,
    cur_code,
    local_phone,
    request_id
  }
});

export const clientTokenUpdated = ({ clientToken }) => ({
  type: CLIENT_TOKEN_UPDATED,
  payload: {
    clientToken
  }
});

export const sgSitePageLoaded = ({ IMPULSE_URLS, CHAT_API }) => ({
  type: SG_SITE_PAGE_LOADED,
  payload: {
    IMPULSE_URLS,
    CHAT_API
  }
});

export const indicateChatIsActive = () => ({ type: INDICATE_CHAT_IS_ACTIVE });

export const setOptions = (options) => ({
  type: SET_OPTIONS,
  payload: options
});
